import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {TeamMember} from '../../models/team-member.model';
import {EditTeamService} from './edit-team.service';
import {LoadingService} from '../../shared/services/loading.service';


@Injectable()
export class TeamMembersResolver {
  private team = inject(EditTeamService);
  private loading = inject(LoadingService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }

  // `null` when the list could not be read - see TeamSizeResolver for why this must not error.
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TeamMember[] | null> {

    const teamMembers$ = this.team.loadTeamMembers();

    return this.loading.showLoaderUntilCompleted(teamMembers$);

  }




}
